import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import icon from "../assets/logo2.png";
import { motion, AnimatePresence } from "framer-motion";
import { getApi, postApi } from "../util/helper";
import { useCustomer } from "../util/CustomerContext";
import { useUser } from "../util/Context";
// import { useCart } from '../util/CartContext'

// const menu = [
//   { id: 1, title: "save", description: "Go to Home Section" },
//   { id: 2, title: "buy", description: "Go to and Shop from Menu Section" },
//   { id: 3, title: "about", description: "Know about us in About Section" },
//   { id: 4, title: "contact", description: "Contact us in Contact Section" },
// ];

function Header() {
  const navigate = useNavigate();
  const { loginCustomer } = useCustomer();
  const { login } = useUser(); // Get login function from useUser hook
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [staffLogin, setStaffLogin] = useState({
    email: "",
    password: "",
  });
  // const { getCartCount } = useCart();
  // const cartCount = getCartCount();
  const [customerLogin, setCustomerLogin] = useState({
    phone: "",
    password: "",
  });

  useEffect(() => {
    getApi(
      "/service",
      (data) => {
        setMenu(data.data.services);
      },
      (err) => {
        console.error("Error fetching menu items:", err);
      },
    );
  }, [menu]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (section) => {
    console.log(section, "scroll to section");
    navigate(`/home/${section}`);
  };

  const scrollToTop = () => {
    // console.log(window.location.pathname, "windeio");
    if (window.location.pathname !== "/home") {
      navigate("/home");
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const closeMobileMenu2 = (item) => {
    setMobileMenuOpen(false);
    navigate(`/home/menu/${item._id}`);
  };

  const customerLoginHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    postApi("/customer/login", customerLogin, (resp) => {
      setLoading(false);
      const customerData = resp.data.data;
      const customerToken = resp.data.token;

      loginCustomer(customerData, customerToken);
      navigate("/customer");
    });

    setOpenModal(false);
    setCustomerLogin({
      phone: "",
      password: "",
    });
    setLoading(false);
  };

  const staffLoginHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    postApi("/auth/signin", staffLogin, (resp) => {
      const role = resp.data.userDetail.role;
      setLoading(false);

      login(resp.data.userDetail, resp.data.assessToken);

      if (role === "admin") {
        navigate("/dashboard");
      } else if (role === "staff") {
        navigate("/staff");
      }
    });

    setOpenModal(false);
    setStaffLogin({
      email: "",
      password: "",
    });
    setLoading(false);
  };

  return (
    <div
      className={`fixed top-0 left-0 right-0 h-[17vh] w-full transition-all duration-500 ease-in-out z-[9000] ${
        scrolled ? "bg-white/80 backdrop-blur-sm" : "bg-transparent"
      }`}
    >
      {/* Desktop Navigation */}
      <div className="hidden md:flex space-x-2 sm:space-x-4 text-white font-bold justify-between items-center mr-2 sm:mr-5 h-full text-sm sm:text-lg">
        <img src={icon} alt="logo" className="h-fit w-[120px]" />
        <div className="flex">
          <div
            onClick={scrollToTop}
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-neutral-400 hover:bg-white/20"
            }`}
          >
            Home
          </div>
          <div
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out relative ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-neutral-400 hover:bg-white/20"
            }`}
            onClick={() => {
              setShowMenuDropdown(!showMenuDropdown);
            }}
          >
            Menu
            <AnimatePresence>
              {showMenuDropdown && (
                <motion.div
                  className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-[10002] animate-dropdownSlideDown"
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.25 }}
                >
                  {menu.map((item) => (
                    <div
                      key={item.id}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/home/menu/${item._id || item.id}`);
                        setShowMenuDropdown(false);
                      }}
                    >
                      {item.title.charAt(0).toUpperCase() + item.title.slice(1)}
                    </div>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div
            onClick={() => scrollToSection("about")}
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-neutral-400 hover:bg-white/20"
            }`}
          >
            About
          </div>
          <div
            onClick={() => scrollToSection("contact")}
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out relative ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-neutral-400 hover:bg-white/20"
            }`}
          >
            Contact Us
          </div>
          <div
            onClick={() => setOpenModal(true)}
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out relative ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-neutral-400 hover:bg-white/20"
            }`}
          >
            Login
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div
        className="md:hidden flex justify-between items-center px-4 py-3 h-full ${
          bg-white/80"
      >
        <img src={icon} alt="logo" className="h-fit w-[100px]" />

        {/* Hamburger Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className={`p-2 rounded-md focus:outline-none z-[10001] ${
            scrolled ? "text-gray-800" : "text-black"
          }`}
          aria-label="Toggle menu"
        >
          <motion.div
            animate={{ rotate: mobileMenuOpen ? 90 : 0 }}
            transition={{ duration: 0.2 }}
          >
            {mobileMenuOpen ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </motion.div>
        </button>
      </div>

      {/* ***************************mpbile*/}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            className="fixed inset- w-full h-screen bg-gray-900/80 z-40"
            initial={{ x: "-100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.6, ease: "easeInOut" }}
          >
            <div className="flex flex-col justify-center items-center h-full space-y-6 text-white font-bold text-2xl">
              <motion.span
                className="cursor-pointer"
                onClick={() => {
                  scrollToTop();
                  closeMobileMenu();
                }}
                whileHover={{ scale: 1.5 }}
                transition={{ duration: 0.6, delay: 0.07, ease: "easeInOut" }}
              >
                Home
              </motion.span>

              <motion.span
                className="cursor-pointer relative"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowMenuDropdown((prev) => !prev);
                }}
              >
                Menu
                <AnimatePresence>
                  {showMenuDropdown && (
                    <motion.div
                      className="absolute top-full left-1/2 -translate-x-1/2
                   mt-4 w-48 bg-white rounded-md shadow-lg py-2 z-[10002]"
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.25 }}
                    >
                      {menu.map((item) => (
                        <div
                          key={item._id}
                          className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          onClick={(e) => {
                            e.stopPropagation();
                            closeMobileMenu2(item);
                            // navigate(`/home/menu/${item._id}`);
                            setShowMenuDropdown(false);
                          }}
                        >
                          {item.title}
                        </div>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.span>

              <motion.span
                onClick={() => {
                  scrollToSection("about");
                  closeMobileMenu();
                }}
                whileHover={{ scale: 1.5 }}
                transition={{ duration: 0.6, delay: 0.07, ease: "easeInOut" }}
              >
                About
              </motion.span>
              <motion.span
                onClick={() => {
                  scrollToSection("contact");
                  closeMobileMenu();
                }}
                whileHover={{ scale: 1.5 }}
                transition={{ duration: 0.6, delay: 0.07, ease: "easeInOut" }}
              >
                Contact Us
              </motion.span>
              <motion.span
                onSubmit={customerLoginHandler}
                onClick={() => setOpenModal(true)}
                whileHover={{ scale: 1.5 }}
                transition={{ duration: 0.6, delay: 0.07, ease: "easeInOut" }}
              >
                Login
              </motion.span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {openModal && (
        <div className="fixed inset-0 z-[10000] flex justify-center items-center h-screen">
          <div
            className="fixed inset-0 bg-black/50 animate-fadeIn h-screen"
            onClick={() => setOpenModal(false)}
          ></div>
          <div
            className={`${
              isAdmin ? "bg-white" : "bg-zinc-950"
            } p-6 rounded-lg shadow-lg w-[80%] max-w-md z-[10001] relative animate-slideUp`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h2
                className={`text-xl font-bold ${
                  isAdmin ? "text-black" : "text-white"
                }`}
              >
                {isAdmin ? "Customer Login" : "Admin Login"}
              </h2>
              <button
                onClick={() => setOpenModal(false)}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                &times;
              </button>
            </div>
            {isAdmin ? (
              <form onSubmit={customerLoginHandler}>
                <input
                  type="text"
                  name="phone"
                  value={customerLogin.phone}
                  onChange={(e) =>
                    setCustomerLogin({
                      ...customerLogin,
                      phone: e.target.value,
                    })
                  }
                  placeholder="Phone Number"
                  className="w-full p-2 border border-gray-300 rounded mb-4"
                />
                <div className="relative w-full mb-4">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={customerLogin.password}
                    onChange={(e) =>
                      setCustomerLogin({
                        ...customerLogin,
                        password: e.target.value,
                      })
                    }
                    placeholder="Password"
                    className="w-full p-2 pr-10 border border-gray-300 rounded"
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
                  >
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#000051"
                      >
                        <path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#000051"
                      >
                        <path d="M607.5-372.5Q660-425 660-500t-52.5-127.5Q555-680 480-680t-127.5 52.5Q300-575 300-500t52.5 127.5Q405-320 480-320t127.5-52.5Zm-204-51Q372-455 372-500t31.5-76.5Q435-608 480-608t76.5 31.5Q588-545 588-500t-31.5 76.5Q525-392 480-392t-76.5-31.5ZM214-281.5Q94-363 40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200q-146 0-266-81.5ZM480-500Zm207.5 160.5Q782-399 832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280q113 0 207.5-59.5Z" />
                      </svg>
                    )}
                  </span>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-200 to-indigo-700 text-white py-2 rounded hover:bg-blue-600"
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>
            ) : (
              <form onSubmit={staffLoginHandler}>
                <input
                  type="text"
                  name="email"
                  value={staffLogin.email}
                  onChange={(e) =>
                    setStaffLogin({
                      ...staffLogin,
                      email: e.target.value,
                    })
                  }
                  placeholder="Email"
                  className="w-full p-2 border border-gray-300 rounded mb-4"
                />
                <div className="relative w-full mb-4">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={staffLogin.password}
                    onChange={(e) =>
                      setStaffLogin({
                        ...staffLogin,
                        password: e.target.value,
                      })
                    }
                    placeholder="Password"
                    className="w-full p-2 pr-10 border border-gray-300 rounded"
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
                  >
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#000051"
                      >
                        <path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#000051"
                      >
                        <path d="M607.5-372.5Q660-425 660-500t-52.5-127.5Q555-680 480-680t-127.5 52.5Q300-575 300-500t52.5 127.5Q405-320 480-320t127.5-52.5Zm-204-51Q372-455 372-500t31.5-76.5Q435-608 480-608t76.5 31.5Q588-545 588-500t-31.5 76.5Q525-392 480-392t-76.5-31.5ZM214-281.5Q94-363 40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200q-146 0-266-81.5ZM480-500Zm207.5 160.5Q782-399 832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280q113 0 207.5-59.5Z" />
                      </svg>
                    )}
                  </span>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-200 to-indigo-700 text-white py-2 rounded hover:bg-blue-600"
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>
            )}
            <span
              className={`${
                isAdmin ? "text-indigo-400" : "text-yellow-600"
              } font-bold text-xs`}
            >
              {isAdmin ? "Are you an admin?" : "Are you a customer?"}{" "}
              <span
                onClick={() => setIsAdmin(!isAdmin)}
                className={`cursor-pointer ${
                  isAdmin ? "text-orange-600" : "text-green-400"
                }`}
              >
                Login here
              </span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
